import { type AuditWindowsFormEntry } from '#packages/data-collection/models/audit-windows-form';

import {
  DirectionFacingLabel,
  OperabilityLabel,
  FrameMaterialLabel,
} from '#apps/client-web/features/audit-form-windows/constants';

import { type ExcelTableMapping } from '../types/excel-mapping';

/**
 * Maps Windows form entries to the "2. Windows" Excel sheet.
 *
 * Each entry occupies one row.
 * Column K (Area) is a formula in the template — skipped.
 */
export const windowsTableMapping: ExcelTableMapping<AuditWindowsFormEntry> = {
  label: 'Windows',
  startRangeName: 'windows_data_start',

  columns: [
    /* B – Section */
    {
      column: 'B',
      getValue: (e) => e.section,
    },
    /* C – Direction facing */
    {
      column: 'C',
      getValue: (e) => (e.directionFacing ? DirectionFacingLabel[e.directionFacing] : undefined),
    },
    /* D – Qty (#) */
    {
      column: 'D',
      getValue: (e) => e.quantity,
    },
    /* E – Width (ft) */
    {
      column: 'E',
      getValue: (e) => e.widthInFeet,
    },
    /* F – Width (in) */
    {
      column: 'F',
      getValue: (e) => e.widthInInches,
    },
    /* G – Height (ft) */
    {
      column: 'G',
      getValue: (e) => e.heightInFeet,
    },
    /* H – Height (in) */
    {
      column: 'H',
      getValue: (e) => e.heightInInches,
    },
    /* I – Width (m) */
    {
      column: 'I',
      getValue: (e) => e.widthInMeters,
    },
    /* J – Height (m) */
    {
      column: 'J',
      getValue: (e) => e.heightInMeters,
    },
    /* K – Area (ft2) (formula — skip) */
    /* L – Operability */
    {
      column: 'L',
      getValue: (e) => (e.operability ? OperabilityLabel[e.operability] : undefined),
    },
    /* M – Frame material */
    {
      column: 'M',
      getValue: (e) => (e.frameMaterial ? FrameMaterialLabel[e.frameMaterial] : undefined),
    },
    /* N – Glazing (Panes) */
    {
      column: 'N',
      getValue: (e) => e.glazingPanes,
    },
    /* O – Notes */
    {
      column: 'O',
      getValue: (e) => e.notes,
    },
  ],
};
